import type { PlayerId } from "@/types/branded";
import { createTournamentContext } from "../createTournamentProvider";
import type { KnockoutGraph } from "../types/graph";

import { knockoutMachine } from "./knockout.machine";

export const KnockoutContext = createTournamentContext(knockoutMachine);

type KnockoutProviderProps = {
  children: React.ReactNode;
  players: PlayerId[];
  initialGraph: KnockoutGraph;
};

export const KnockoutProvider = ({ children, players, initialGraph }: KnockoutProviderProps) => {
  return (
    <KnockoutContext.Provider options={{ input: { players, initialGraph } }}>
      {children}
    </KnockoutContext.Provider>
  );
};
